import { render, staticRenderFns } from "./RecomendSignUp.vue?vue&type=template&id=24127e23&scoped=true&lang=pug&"
import script from "./RecomendSignUp.vue?vue&type=script&lang=js&"
export * from "./RecomendSignUp.vue?vue&type=script&lang=js&"
import style0 from "./RecomendSignUp.vue?vue&type=style&index=0&id=24127e23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24127e23",
  null
  
)

export default component.exports